import { useEffect, useRef, useState } from 'react'
import { getUserProjects } from '../../../utils/SessionStorageUtils'
import { auto } from '@popperjs/core'
import { useAuth } from '../../modules/auth'
import { Error404 } from '../../modules/errors/components/Error404'
import { useUserContextQuery } from '../../modules/auth/core/_requests'

function TaskManagerWrapper() {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const { auth } = useAuth()
  const [enabled, setEnabled] = useState<boolean>(false)
  const {
    isFetched,
    isSuccess,
    isError,
    data: userContextData,
  } = useUserContextQuery(auth!, enabled)

  useEffect(() => {
    if (userContextData?.projects) {
      sessionStorage.setItem('userProjects', JSON.stringify(userContextData.projects))
    }
  }, [userContextData])

  const projects =
    userContextData?.projects.filter((project: any) => project.type?.toLowerCase() === 'project') ||
    (getUserProjects('userProjects') || []).filter(
      (project) => project.type?.toLowerCase() === 'project'
    )

  useEffect(() => {
    setEnabled(false)
  }, [isSuccess, isError])

  useEffect(() => {
    const handleMessage = (event: any) => {
      if (event.origin !== process.env.REACT_APP_TASKMANAGER_CLIENT_URL) return
      const data = event.data

      if (data && data.type === 'invalidate') {
        setEnabled(true)
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  if (projects && projects.length > 0) {
    return (
      <div className='row m-0'>
        <div className='card'>
          <div className='card-body p-0' style={{ scrollbarWidth: 'none' }}>
            <div
              className='row'
              style={{ overflow: 'hidden', height: 'calc(100vh - 110px - 45px)' }}
            >
              <iframe
                ref={iframeRef}
                src={`${process.env.REACT_APP_TASKMANAGER_CLIENT_URL}/invPortal/project/${
                  projects[projects.length - 1].id
                }/${auth!}`}
                title='Task Manager'
                loading='eager'
                width='100%'
                style={{ border: 'none', height: '100%', padding: 0, overflow: auto }} // Fallback height if 0
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return <Error404 />
  }
}

export default TaskManagerWrapper
